export const ONBOARDING_FINISHED = 'ONBOARDING_FINISHED';
export const EXPOSURE_ONBOARDING_FINISHED = 'EXPOSURE_ONBOARDING_FINISHED';
export const START_SCREEN_SHOWED = 'START_SCREEN_SHOWED';
export const UPLOAD_HISTORICAL_DATA_REQUESTED =
  'UPLOAD_HISTORICAL_DATA_REQUESTED';
export const UPLOAD_HISTORICAL_DATA_FINISHED =
  'UPLOAD_HISTORICAL_DATA_FINISHED';
export const UPLOAD_HISTORICAL_DATA_ENDED = 'UPLOAD_HISTORICAL_DATA_ENDED';
